import { useAuth } from "./AuthContext";

/** `base` for the signed-in account, the web twin of mobile's
 *  currentUserScopedKey; null when nobody is signed in. */
export const useAccountKey = (base: string): string | null => {
  const { state } = useAuth();
  return state.status === "signed_in" ? `${base}.${state.user.sub}` : null;
};
